import { createAction } from "@reduxjs/toolkit";

export const updateSearchFilter = createAction("cart/updateSearchFilter");
export const updateCategoryFilter = createAction("cart/updateCategoryFilter");
